import { withChartLayout } from 'components/common';
import VitalSigns from 'components/features/chart/vital-signs/vital-signs/VitalSigns';

const VitalSignsPage = withChartLayout('Vital Signs')(VitalSigns);
export default VitalSignsPage;
